<div class="single-equipment-provisioning">
  <div *ngIf="loading">
    <ngx-skeleton-loader [theme]="{'height':'500px'}"></ngx-skeleton-loader>
  </div>
  <div *ngIf="!loading && isMessageVisible" class="single-equipment-provisioning__messages">
    <div class="vox-inline-message vox-inline-message_light-grey">
      <div *ngIf="equipment.pbx === null">
        <i class="icon-small-alert"></i>
        <span translate>equipment.details.nav-tabs.provisioning.messages.no-pbx</span>
      </div>
      <div *ngIf="equipment.pbx !== null">
        <i class="icon-small-alert"></i>
        <span *ngIf="equipment.model !== 'AIR' && !equipment.user" translate>equipment.details.nav-tabs.provisioning.messages.no-user</span>
        <span *ngIf="equipment.model === 'AIR' && equipment.handsets.length === 0" translate>equipment.details.nav-tabs.provisioning.messages.no-handset</span>
      </div>
    </div>
  </div>
  <section *ngIf="!loading && (equipment.user || equipment.handsets.length !== 0)">
    <div class="row">
      <div class="col-12 col-xl-6">
        <h3 translate>equipment.details.nav-tabs.provisioning.provisioning-override</h3>
        <textarea rows="20" [(ngModel)]="overrideFragment"></textarea>
      </div>
      <div class="col-12 col-xl-6">
        <h3 translate>equipment.details.nav-tabs.provisioning.provisioning-file</h3>
        <textarea rows="20">{{provisioningFile}}</textarea>
      </div>
    </div>
    <button class="vox-btn vox-btn-primary"
      [disabled]="company && company.readOnly"
      (click)="onUpdateOverrideFragment()"
      [ladda]="loadingUpdate"
      data-spinner-color="white"
      data-style="zoom-in">
      <span translate>equipment.details.buttons.save</span>
    </button>
  </section>
</div>
